import { SCREENS } from "utils/constants";
import List from "./List";
import Detail from "./Detail";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.SEQUENCE_TEMPLATES.LIST.path,
    exact: true,
    element: <List />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.SEQUENCE_TEMPLATES.DETAIL.path}/:id`,
    exact: true,
    element: <Detail />,
  },
];

export default routes;
